import API from "@/api/lib/api";

export const getAllCreateYourOwnGenerals = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/create-your-own-generals`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleCreateYourOwnGeneral = async (id) => {
  try {
    const response = await API.get(`restaurant/create-your-own-generals/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createCreateYourOwnGeneral = async (data) => {
  try {
    const response = await API.post(`restaurant/create-your-own-generals`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateCreateYourOwnGeneral = async (id, data) => {
  try {
    const response = await API.put(`restaurant/create-your-own-generals/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteCreateYourOwnGeneral = async (id) => {
  try {
    const response = await API.delete(`restaurant/create-your-own-generals/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleCreateYourOwnGeneralStatus = async (id) => {
  try {
    const response = await API.put(
      `restaurant/create-your-own-generals/${id}/toggle-status`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleCreateYourOwnGeneralAvailability = async (id, data) => {
  try {
    const response = await API.put(
      `restaurant/create-your-own-generals/${id}/toggle-availability`,
      data
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

